<script>
export default {
  name: 'CountriesList'
}
</script>
<template>
  <div class="countries-list">
    <div class="app-content">
      <h2 class="main-page__title">
        Страны
      </h2>
      <div class="countries-list__content">
        <div
          v-for="item in 10"
          :key="item"
          class="countries-list__content-item"
        >
          <div class="countries-list__content-item-letter">
            А {{ item }}
          </div>
          <div class="countries-list__content-item-list">
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
            <a href="#">Абхазия</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>